module.exports = __webpack_public_path__ + "img/verify.9df47a83.png";